import React from "react";
import { APP_STORE_URL } from "./config";

export function AppleLogo(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden {...props}>
      <path d="M16.37 1.43c0 1.14-.49 2.27-1.18 3.08-.74.9-1.99 1.57-2.99 1.57-.12 0-.23-.02-.3-.03-.01-.06-.04-.22-.04-.39 0-1.15.57-2.27 1.21-2.98.8-.94 2.14-1.64 3.25-1.68.03.13.05.28.05.43zm4.56 15.71c-.03.07-.46 1.58-1.52 3.12-.94 1.34-1.94 2.71-3.43 2.71-1.52 0-1.9-.88-3.63-.88-1.7 0-2.3.91-3.67.91-1.38 0-2.33-1.26-3.43-2.8C3.96 18.38 2.93 15.57 2.93 12.92c0-4.28 2.8-6.55 5.55-6.55 1.45 0 2.68.95 3.6.95.87 0 2.22-1.01 3.9-1.01.62 0 2.89.06 4.38 2.19-.13.09-2.39 1.37-2.39 4.19 0 3.26 2.86 4.42 2.96 4.45z" />
    </svg>
  );
}

export default function AppStoreBadge({ light = false, small = false, className = "", testId }) {
  const cls = ["store-badge", light && "store-badge--light", small && "store-badge--sm", className]
    .filter(Boolean)
    .join(" ");
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      className={cls}
      aria-label="Download Meet Leo on the App Store"
      data-testid={testId}
      onClick={() => window.posthog?.capture?.("app_store_click", { placement: testId })}
    >
      <AppleLogo />
      <span className="text-left">
        <small>Download on the</small>
        <strong>App Store</strong>
      </span>
    </a>
  );
}
